import { makeStyles } from '@material-ui/core';
import ArlaLogo from '../../../public/logos/Arla_Logo_Primary_RGB.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 32,
  }
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
      <img className={classes.img} src={ArlaLogo} alt="Arla" />
  );
};

export default LogoIcon;
